import { useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { webSocketActions } from '../../../actions/medichat/websocket/websocketActions';

const useWebSocket = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.patientAuth.user);
  const wsRef = useRef(null);

  const connect = useCallback(() => {
    if (wsRef.current?.readyState === WebSocket.OPEN) return;

    wsRef.current = new WebSocket('ws://127.0.0.1:8000/ws/medichat/');

    wsRef.current.onopen = () => {
      dispatch({ type: webSocketActions.CONNECT });
      wsRef.current.send(
        JSON.stringify({
          type: 'test_message',
          message: 'Connected to WebSocket'
        })
      );
    };

    wsRef.current.onmessage = (event) => {
      const data = JSON.parse(event.data);
      dispatch({ type: webSocketActions.RECEIVE_MESSAGE, payload: data });
    };

    wsRef.current.onerror = (error) => {
      console.error('WebSocket Error:', error);
      dispatch({
        type: webSocketActions.WEBSOCKET_ERROR,
        payload: error.message
      });
    };

    wsRef.current.onclose = () => {
      dispatch({ type: webSocketActions.DISCONNECT });
    };
  }, [dispatch]);

  useEffect(() => {
    connect();

    return () => {
      if (wsRef.current) {
        wsRef.current.close();
        wsRef.current = null;
      }
      dispatch({ type: webSocketActions.DISCONNECT });
    };
  }, [connect, dispatch]);

  const sendReaction = useCallback(
    (postId, reactionType) => {
      if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {
        connect();
      }

      const message = {
        type: 'reaction',
        post_id: postId,
        user_id: user?.id,
        reaction_type: reactionType,
        timestamp: new Date().toISOString()
      };

      if (wsRef.current.readyState === WebSocket.OPEN) {
        wsRef.current.send(JSON.stringify(message));
      } else {
        wsRef.current.onopen = () => {
          wsRef.current.send(JSON.stringify(message));
        };
      }
    },
    [user?.id, connect]
  );

  return { sendReaction };
};

export default useWebSocket;
